var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h3',{staticClass:"title",class:{ current: _vm.item.isCurrentStatus }},[_vm._v(_vm._s(_vm.title))]),(_vm.item.comment)?_c('p',{staticClass:"message"},[_vm._v("«"+_vm._s(_vm.item.comment)+"»")]):_vm._e(),_c('span',{staticClass:"date"},[_vm._v(_vm._s(_vm.date))])])
}
var staticRenderFns = []

export { render, staticRenderFns }